import { ApiaUtilModals } from './modals/ApiaUtilModals';
import { ApiaUtilNotifications } from './notifications/ApiaUtilNotifications';
import { ApiaUtilTabsController } from './tabs/ApiaUtilTabsController';
import { ApiaUtilDialogs } from './dialogs/ApiaUtilDialogs';
import { ApiaUtilParsers } from './parsers/ApiaUtilParsers';
import { ApiaUtilTooltips } from './tooltips/ApiaUtilTooltips';
import { ApiaUtilMenu } from './menu/ApiaUtilMenu';
import { ApiaUtilMouse } from './mouse/ApiaUtilMouse';

export class ApiaUtil {
  static #instance: ApiaUtil;
  public static get instance() {
    if (!this.#instance) {
      this.#instance = new ApiaUtil();
    }

    return this.#instance;
  }

  private constructor() {
    this.dialogs = new ApiaUtilDialogs();
    this.menu = new ApiaUtilMenu();
    this.modals = new ApiaUtilModals();
    this.mouse = new ApiaUtilMouse();
    this.notifications = new ApiaUtilNotifications(this);
    this.parsers = new ApiaUtilParsers();
    this.tabs = new ApiaUtilTabsController();
    this.tooltips = new ApiaUtilTooltips();
  }

  dialogs: ApiaUtilDialogs;
  menu: ApiaUtilMenu;
  modals: ApiaUtilModals;
  mouse: ApiaUtilMouse;
  notifications: ApiaUtilNotifications;
  parsers: ApiaUtilParsers;
  tabs: ApiaUtilTabsController;
  tooltips: ApiaUtilTooltips;

  Component = () => {
    return (
      <>
        <this.dialogs.Component />
        <this.modals.Component />
        <this.notifications.Component />
        <this.tooltips.Component />
        <this.menu.Component />
      </>
    );
  };
}
